import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { updateLocationInfo } from './../redux/actions/locations'
import { config } from '../config'

export function useChargersStatusPeriodicUpdate() {
    const dispatch = useDispatch()
    const socketRef = useRef<WebSocket | null>(null)

    useEffect(() => {
        // Otvoríme socket iba ak ešte neexistuje
        if (!socketRef.current) {
            const ws = new WebSocket(`${config.websocket}/ocpp/client_chargers_status`, [
                'ocpp1.6',
            ])
            socketRef.current = ws

            ws.onmessage = (event) => {
                const chargerInfoChanged = JSON.parse(event.data)
                console.log("WS List:", chargerInfoChanged)
                dispatch(updateLocationInfo(chargerInfoChanged))
            }
        }

        // CLEAN-UP pri demontovaní zoznamu
        return () => {
            if (socketRef.current) {
                socketRef.current.close()
                socketRef.current = null
            }
        }
    }, [dispatch])
}